import Papa from 'papaparse';


export async function parseIronDomeCSV(file: File): Promise<{ csvData: any[] } | null> {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        try {
          const hasParsingErrors = results.errors.length > 0;
          if (hasParsingErrors) {
            console.warn('CSV parsing errors:', results.errors);
          }

          const csvData = results.data.map((row: any) => {
            return cleanRowData(row);
          });

          const validRows = filterValidRows(csvData);

          if (validRows.length === 0) {
            reject(new Error('No valid data found in CSV file'));
            return;
          }

          resolve({ csvData: validRows });
        } catch (error) {
          reject(error);
        }
      },
      error: (error) => {
        reject(error);
      },
    });
  });
}
function cleanRowData(row: any): any {
  const cleanedRow: any = {};

  Object.keys(row).forEach((key) => {
    const normalizedKey = key.trim();
    cleanedRow[normalizedKey] = row[key];
  });

  return cleanedRow;
}

function filterValidRows(csvData: any[]): any[] {
  return csvData.filter((row) => {
    const rowValues = Object.values(row);
    const hasAnyNonEmptyValue = rowValues.some((val) => {
      if (!val) {
        return false;
      }
      const stringValue = String(val);
      return stringValue.trim() !== '';
    });

    return hasAnyNonEmptyValue;
  });
}
